import React from 'react'
import s from './Reviews.less'
import { formatNumber } from '../../utils/number'

export default function Reviews({ reviews }) {
  if (!reviews) return null
  const { averageNote, maxNote, numberOfReviews } = reviews
  const max = maxNote ? `/${maxNote}` : ''
  const number = numberOfReviews ? `(${numberOfReviews} avis)` : ''
  return (
    <span className={s.text}>
      <span className={s.averageNote}>{formatNumber(averageNote)}</span>
      {max} {number}
    </span>
  )
}
